import * as React from "react"
import { Col, Row } from "react-grid-system"
import SearchField from "../atoms/inputs/SearchField"
import DatePicker from "../atoms/inputs/DatePicker"
import Checkbox from "../atoms/inputs/Checkbox"
import { HorizontalSpacer, Spacer } from "../atoms/spacers"
import ReceiptsCard from "../organisms/ReceiptsCard"
import { getformattedReceipts } from "../../utils/formatters"
import LoadingSpinner from "../atoms/LoadingSpinner"
import dayjs from "dayjs"
import FilterDropdown from "../atoms/inputs/FilterDropdown"
import { ApolloError } from "@apollo/client"

export enum RECEIPT_PURCHASE_TYPES {
  STORE_PURCHASE = "direct",
  TOPUP = "topup",
  RENTAL = "rental",
}

export type ReceiptsQueryHookType = () => {
  receiptsData: any
  error: ApolloError | undefined
  loading: boolean
  refetch: () => void
}

interface ReceiptsPageProps {
  queryHook: ReceiptsQueryHookType
}

const filterAlternatives: Array<{ id: string | number; title: string }> = [
  {
    id: RECEIPT_PURCHASE_TYPES.STORE_PURCHASE,
    title: "Store purchase",
  },
  {
    id: RECEIPT_PURCHASE_TYPES.TOPUP,
    title: "Topup",
  },
  {
    id: RECEIPT_PURCHASE_TYPES.RENTAL,
    title: "Rental",
  },
]

const ReceiptsPage: React.FunctionComponent<ReceiptsPageProps> = ({ queryHook }) => {
  const { receiptsData, error, loading, refetch } = queryHook()
  const [allTime, setAllTime] = React.useState(true)
  const [searchValue, setSearchValue] = React.useState<undefined | string>(undefined)
  const [fromDate, setFromDate] = React.useState<undefined | string>(undefined)
  const [toDate, setToDate] = React.useState<undefined | string>(undefined)

  const [selectedFilterIds, setSelectedFilterIds] = React.useState<Array<string | number>>([
    RECEIPT_PURCHASE_TYPES.TOPUP,
    RECEIPT_PURCHASE_TYPES.STORE_PURCHASE,
    RECEIPT_PURCHASE_TYPES.RENTAL,
  ])
  const onClickFilterItem = (id: string | number) => {
    if (selectedFilterIds.includes(id)) {
      const filterd = selectedFilterIds.filter((x) => x !== id)
      setSelectedFilterIds(filterd)
    } else {
      setSelectedFilterIds([...selectedFilterIds, id])
    }
  }
  const onClickSelectAllFilterOptions = () => {
    setSelectedFilterIds([
      RECEIPT_PURCHASE_TYPES.TOPUP,
      RECEIPT_PURCHASE_TYPES.STORE_PURCHASE,
      RECEIPT_PURCHASE_TYPES.RENTAL,
    ])
  }

  React.useEffect(() => {
    refetch()
  }, [])

  if (error) {
    console.log("error fetching receipts")
  }

  const myReceipts =
    receiptsData && getformattedReceipts(receiptsData, searchValue, allTime, fromDate, toDate, selectedFilterIds)

  const onSearch = (value: any) => {
    setSearchValue(value)
  }

  const onSelectFromDate = (value: string) => {
    setFromDate(value)
    !toDate && setToDate(dayjs().add(1, "day").format("YYYY-MM-DD"))
    setAllTime(false)
  }
  const onSelectToDate = (value: string) => {
    setToDate(value)
    !fromDate && setFromDate(dayjs().format("YYYY-MM-DD"))
    setAllTime(false)
  }
  const onCheckAllTime = () => {
    if (allTime) {
      setAllTime(false)
    } else {
      setAllTime(true)
      setFromDate(undefined)
      setToDate(undefined)
    }
  }

  return (
    <div>
      <Row>
        <Col md={2}>
          <SearchField onChange={(e) => onSearch(e)} />
        </Col>
        <Col md={2}>
          <FilterDropdown
            items={filterAlternatives}
            title="Filter"
            onClickItem={(e) => onClickFilterItem(e)}
            selectedValues={selectedFilterIds}
            selectAllTitle="All purchase types"
            onClickSelectAll={onClickSelectAllFilterOptions}
          />
        </Col>
        <Col md={6}>
          <Row align="center">
            <DatePicker onSelectDate={onSelectFromDate} value={fromDate} />
            -
            <DatePicker onSelectDate={onSelectToDate} value={toDate} />
            <Spacer spacing={1} />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox checked={allTime} onChange={onCheckAllTime} />
              <Spacer spacing={1} /> All time
            </div>
          </Row>
        </Col>
      </Row>
      <HorizontalSpacer spacing={2} />
      {loading && <LoadingSpinner />}
      {myReceipts && <ReceiptsCard receipts={myReceipts} />}
      <HorizontalSpacer spacing={2} />
    </div>
  )
}

export default ReceiptsPage
